function CrossSVG(props) {
  return (
    <svg
      className="shape-1 d-none d-sm-block"
      style={{fill: props.data.startColor}}
      viewBox="0 0 240.83 240.83"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-32.54"
        y="78.39"
        width="305.92"
        height="84.05"
        rx="42.03"
        transform="translate(120.42 -49.88) rotate(45)"
      ></rect>
      <rect
        x="-32.54"
        y="78.39"
        width="305.92"
        height="84.05"
        rx="42.03"
        transform="translate(-49.88 120.42) rotate(-45)"
      ></rect>
    </svg>
  );
}

export default CrossSVG;
